module.exports = __webpack_public_path__ + "media/club/icookin_device-7d1b1caa.webp";